<template>
  <section
    :class="{
      'form-builder--simple': fullWidth,
    }"
    class="form-builder"
  >
    <form-head
      :h2="h2"
      v-if="list.title && !fullWidth"
      :title="list.title"
      :sub-title="list.subTitle"
    />
    <ul>
      <li
        v-for="(item, index) in list.list"
        :key="index"
      >
        <custom-input
          v-if="item.components==='inputs' && item.type !== 'password' && item.show != false"
          :value="item.value"
          placeholder
          :is-horizontal="isHorizontal"
          :label="item.label"
          :active="!item.isDisabled"
          :alert="false"
          :list="item.name"
          :max="item.maxLength"
          :svg="item.svg"
          :type="item.type"
          :clickable-svg="item.isSvgClickable"
          @fill-input="updatedInputs"
        >
          <ul
            class="error"
            v-if="errors && errors[item.name] && errors[item.name].$error"
          >
            <li
              v-for="(error, idx) in item.errors"
              :key="idx"
            >
              <span v-if="!errors[item.name][error.type]">{{ error.label }}</span>
            </li>
          </ul>
        </custom-input>
        <custom-input
          v-if="item.type==='password' && item.show != false"
          :value="item.value"
          placeholder
          :is-horizontal="isHorizontal"
          :label="item.label"
          :active="!item.isDisabled"
          :alert="false"
          :list="item.name"
          :max="item.maxLength"
          :type="item.type"
          svg="#icon-eye"
          :clickable-svg="item.isSvgClickable"
          @fill-input="updatedInputs"
        >
          <ul
            class="error"
            v-if="errors && errors[item.name] && errors[item.name].$error"
          >
            <li
              v-for="(error, idx) in item.errors"
              :key="idx"
            >
              <span v-if="!errors[item.name][error.type]">{{ error.label }}</span>
            </li>
          </ul>
        </custom-input>

        <shared-fetch-email
          v-if="item.components==='email' "
          :value="item.value"
          placeholder
          :is-horizontal="isHorizontal"
          :label="item.label"
          :active="true"
          :alert="false"
          :list="item.name"
          :svg="item.svg"
          :type="item.type"
          :error="errors[item.name].$error"
          :loading="fetch"
          :clickable-svg="item.isSvgClickable"
          @fill-input="updatedInputs"
        >
          <ul
            class="error"
            v-if="errors[item.name].$error"
          >
            <li
              v-for="(error, idx) in item.errors"
              :key="idx"
            >
              <span v-if="!errors[item.name][error.type]">{{ error.label }}</span>
            </li>
          </ul>
          <div v-if="!errors[item.name].$error && inputValue">
            <span
              v-if="!fetch && inputValue.name !== 'undefined' && inputValue.name.length"
              class="form-builder__success"
            >{{ $t('commons.email_verification') }}</span>
          </div>
        </shared-fetch-email>
        <shared-text-area
          v-if="item.components==='textarea' && item.show != false"
          :value="item.value"
          placeholder
          :is-horizontal="isHorizontal"
          :label="item.label"
          :active="true"
          :alert="false"
          :list="item.name"
          svg
          :error="errors[item.name].$error"
          @fill-input="updatedInputs"
        >
          <ul
            class="error"
            v-if="errors[item.name].$error"
          >
            <li
              v-for="(error, idx) in item.errors"
              :key="idx"
            >
              <span v-if="!errors[item.name][error.type]">{{ error.label }}</span>
            </li>
          </ul>
        </shared-text-area>
        <dates-inputs
          v-else-if="item.components==='dateInputs' && item.show != false"
          :value="item.value"
          :label="item.label"
          :name="item.name"
          :is-horizontal="isHorizontal"
          :error="errors && errors[item.name]"
          @updatedDateInputs="updatedDateInputs"
        >
          <ul
            class="error"
            v-if="errors && errors[item.name] && errors[item.name].$error"
          >
            <li
              v-for="(error, idx) in item.errors"
              :key="idx"
            >
              <span v-if="!errors[item.name].custom[error.type]">{{ error.label }}</span>
            </li>
          </ul>
        </dates-inputs>
        <select-list
          v-else-if="item.components==='list' && item.show != false"
          svg="#icon-arrow2"
          :is-horizontal="isHorizontal"
          :list-from-store="item.list"
          :placeholder="item.placeholder"
          :label="item.label"
          :name="item.name"
          :selected="item.selected || item.value"
          :error="errors[item.name]"
          @updatedSelecter="updatedSelecter"
        >
          <ul
            class="error"
            v-if="errors[item.name] && errors[item.name].$error"
          >
            <li
              v-for="(error, idx) in item.errors"
              :key="idx"
            >
              <span v-if="!errors[item.name][error.type]">{{ error.label }}</span>
            </li>
          </ul>
        </select-list>
        <div
          v-else-if="item.components==='br' && item.show != false"
          class="form-builder__br"
        />

        <shared-radio
          v-else-if="item.components==='radio' && item.show != false"
          :errors="errors && errors[item.name]"
          :active="item.selected || item.value"
          :list="item.list"
          :name="item.name"
          :is-horizontal="isHorizontal"
          :label="item.placeholder"
          @toggle="updateRadioButton"
        >
          <ul
            class="error error__radio"
            v-if="errors && errors[item.name] && errors[item.name].$error"
          >
            <li
              v-for="(error, idx) in item.errors"
              :key="idx"
            >
              <span v-if="!errors[item.name][error.type]">{{ error.label }}</span>
            </li>
          </ul>
        </shared-radio>
      </li>
    </ul>
  </section>
</template>
<script>
import CustomInput from './CustomInput'
import SharedFetchEmail from './SharedFetchEmail'
import SharedTextArea from './SharedTextArea'
import SharedRadio from './SharedRadio'
import DatesInputs from './DatesInputs/DatesInputs'
import SelectList from './SelectList/SelectList'
import FormHead from './FormHead'

export default {
  props: {
    list: {
      type: Object,
      default: null,
    },
    errors: {
      type: Object,
      default: null,
    },
    isHorizontal: {
      type: Boolean,
      default: false,
    },
    fetch: {
      type: Boolean,
      default: false,
    },
    isCentered: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    h2: {
      type: Boolean,
      default: false,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputValue: null,
      checkbox: {
        alert: false,
      },
    }
  },
  components: {
    CustomInput,
    SharedFetchEmail,
    SharedTextArea,
    SharedRadio,
    DatesInputs,
    SelectList,
    FormHead,
  },
  methods: {
    updatedInputs(val) {
      this.inputValue = val
      this.$emit('updateInputs', val)
    },
    updatedDateInputs(val) {
      this.$emit('updateDateInputs', val)
    },
    updatedSelecter(val) {
      this.$emit('updateSelecterInputs', val)
    },
    updateRadioButton(val) {
      this.$emit('updateRadioButton', val)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../../../_src/sass/config/vars';
@import '../../../../../_src/sass/config/mixins';
@import '../../../../../_src/sass/config/responsive';

.form-builder {
  border: 1px solid $desert-storm;
  padding: 20px 30px;

  @include teq-breakpoint($medium) {
    padding: 20px 50px;
  }

  &__br {
    border-top: 1px solid $desert-storm;
    margin: 30px 0 10px 0;
    width: 100%;
  }

  &--simple {
    border: none;
    padding: 0;
  }

  &__success {
    @include successInputs;
  }

  .error__radio {
    left: 50%;
    position: absolute;
    top: 55px;
  }
}
</style>
